class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        const content = this.getSectionInnerHTML(html, '.shopify-section');
        if (content) {
          document.getElementById('mini-cart').innerHTML = content;
        }
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error('MiniCart fetch error:', e);
      });
  }

  open() {
    if (!this.drawer) {
      this.drawer = document.querySelector('cart-drawer');
    }
    if (!this.drawer) {
      console.warn('cart-drawer element not found');
      return;
    }
    
    const detailsElement = this.drawer.querySelector('details');
    if (!detailsElement) {
      console.warn('details element not found in cart-drawer');
      return;
    }
    
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    if (typeof this.drawer.openMenuDrawer === 'function') {
      this.drawer.openMenuDrawer();
    } else {
      // Fallback: manually open details
      detailsElement.setAttribute('open', '');
    }
  }

  renderContents(parsedState) {
    try {
      this.productId = parsedState.id;
      
      this.getSectionsToRender().forEach((section) => {
        const element = document.getElementById(section.id);
        if (element && parsedState.sections && parsedState.sections[section.id]) {
          const content = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          if (content) {
            element.innerHTML = content;
          }
        }
      });

      // Update any custom cart count elements (e.g., header-mustakil)
      this.updateCartCount(parsedState);

      this.open();
    } catch (e) {
      console.error('MiniCart renderContents error:', e);
      // Still try to open the drawer
      this.open();
    }
  }

  updateCartCount(parsedState) {
    // Get cart count from parsedState (either from sections or direct property)
    let itemCount = 0;
    
    if (parsedState.item_count !== undefined) {
      itemCount = parsedState.item_count;
    } else if (parsedState.sections && parsedState.sections['mini-cart']) {
      // Parse item count from mini-cart section HTML (data-cart-item-count attribute on form)
      try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(parsedState.sections['mini-cart'], 'text/html');
        const formEl = doc.querySelector('[data-cart-item-count]');
        if (formEl) {
          itemCount = parseInt(formEl.dataset.cartItemCount) || 0;
        }
      } catch (e) {
        console.error('Error parsing cart count:', e);
      }
    }

    // Update all data-cart-count elements (custom headers like header-mustakil)
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = itemCount;
    });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const element = doc.querySelector(selector);
      return element ? element.innerHTML : null;
    } catch (e) {
      console.error('Error parsing section HTML:', e);
      return null;
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
